(function(){
    'use strict'

    angular
    .module('app.login')
    .controller('Login', Login);

    Login.$inject = ['$animationsSrv', 'LoginService', 'logger', '$location', 'UserInfoService'];

    function Login($animationsSrv, LoginService, logger, $location, UserInfoService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        vm.title = 'Usuarios';

        vm.interface = {
            loginError: false,
            passwordSuccess: false,
            passwordError: false
        };

        vm.user = {
            grant_type: 'password',
            userName: '',
            userDisplayName: '',
            password: '',
            rememberMe: false,
            isAuthenticated: false
        };

        logOutUser();

        vm.goToLoadPage = function(){
            
            var permisosInscripciones = UserInfoService.getPermisosInscripciones();

            if(UserInfoService.esOrganizador())
            {
                if(permisosInscripciones.ver) {
                    $location.path('/inscripciones');
                }
                else{
                    $location.path('/principal');
                }
            }
            else
            {
                $location.path('/eventos');
            }
        };

        vm.login = function(){
            if(validate()){
                var promise = LoginService.login(vm.user);
                vm.interface.loginError = false;
                promise.then(function(response){

                    if (response.data != null) {  
                        if (response.data.error == "invalid_grant") {  
                            vm.user.isAuthenticated = false;  
                            logger.error('El usuario o el password son incorrectos');  
                        }  
                        else {  
  
                            UserInfoService.setToken(response.data.access_token);
                            LoginService.getLoginInfo()
                            .then(function(userLoginData){
                                vm.user.isAuthenticated = true;

                                UserInfoService.setUser(vm.user, response.data, userLoginData);

                                vm.goToLoadPage(); 
                                logger.success('Usuario logueado con éxito'); 
                            })
                            .catch(function(error){
                                logger.error('Problemas al obtener la informacion del login.');
                            });
                        }  
                    } else {  
                        vm.user.isAuthenticated = false;  
                        logger.error('Problemas de comunicacion.');
                    } 

                }).catch(function(error){
                    logger.error('El usuario o el password son incorrectos');
                    vm.interface.loginError = true;
                });
            }
        };

        function validate(){
            if(vm.user.userName === ''){
                logger.error('El usuario es requerido');
                return false;
            }

            if(vm.user.password === ''){
                logger.error('El password es requerido');
                return false;
            }

            return true;

        }

        function logOutUser(){
            UserInfoService.logoutUser();
        }

    }
})();